import { Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';

const ThinkSkillsHeader = ({ fontColor }) => (
  <Box width="100% !important" mb={4} textAlign="center">
    <Typography
      variant="h1"
      sx={{
        fontFamily: '"Merriweather", serif',
        fontWeight: 900,
        fontSize: '2.55rem !important',
        display: 'inline',
        color: fontColor || 'unset',
      }}
    >
      Your ThinkSkills results
    </Typography>
    {/* <Typography component="span" sx={{ fontSize: '20px !important', fontWeight: 700, display: 'inline', color: fontColor || 'unset' }}>
      Your THINK
    </Typography>
    {/* <Typography component="span" sx={{ fontSize: '20px !important', fontWeight: 700, display: 'inline', color: fontColor || 'unset' }}>
      Your THINK
    </Typography>
    <Typography component="span" sx={{ fontSize: '20px !important', fontWeight: 300, display: 'inline', color: fontColor || 'unset' }}>
      SKILLS
    </Typography>
    <Typography component="span" sx={{ fontSize: '20px !important', fontWeight: 700, display: 'inline', color: fontColor || 'unset' }}>
      {' '}results
    </Typography> */}
  </Box>
);

ThinkSkillsHeader.propTypes = {
  fontColor: PropTypes.string,
};

export default ThinkSkillsHeader;